(function () {
  'use strict';
  if (window.__sxBundlePicker) return;
  window.__sxBundlePicker = true;

  var css = [
    '.sx-bp{margin:6px 0 4px;display:grid;gap:12px}',
    '.sx-bp__h{margin:0;font-size:1.05rem;font-weight:800;color:#111}',
    '.sx-bp__card{display:block;position:relative;border:1.5px solid #d9d9d9;border-radius:14px;padding:14px;background:#fff;cursor:pointer;transition:border-color .15s,box-shadow .15s}',
    '.sx-bp__card.is-on{border:2.5px solid #111;box-shadow:0 6px 18px rgba(0,0,0,.08)}',
    '.sx-bp__radio{position:absolute;opacity:0;pointer-events:none}',
    '.sx-bp__row{display:flex;align-items:center;gap:12px}',
    '.sx-bp__thumb{width:56px;height:56px;border-radius:10px;object-fit:cover;background:#f2f2f2;flex:none}',
    '.sx-bp__txt{flex:1;display:grid;gap:3px;min-width:0}',
    '.sx-bp__title{font-weight:800;font-size:1rem;color:#111}',
    '.sx-bp__save{justify-self:start;background:#111;color:#fff;font-size:.7rem;font-weight:700;padding:3px 8px;border-radius:999px;letter-spacing:.03em}',
    '.sx-bp__prices{display:grid;justify-items:end;gap:2px;white-space:nowrap}',
    '.sx-bp__now{font-weight:800;font-size:1rem;color:#111}',
    '.sx-bp__was{font-size:.8rem;color:#8a8a8a;text-decoration:line-through}',
    '.sx-bp__picks{display:flex;flex-wrap:wrap;gap:8px;margin-top:12px}',
    '.sx-bp__pick{display:grid;gap:4px;font-size:.72rem;color:#666}',
    '.sx-bp__pick select{min-width:92px;height:40px;border:1.5px solid #cfcfcf;border-radius:10px;padding:0 10px;font-size:.9rem;background:#fff;color:#111}',
    '.sx-bp__btns{display:grid;gap:8px;margin-top:4px}',
    '.sx-bp__btn{min-height:54px;border-radius:999px;font-weight:800;font-size:.95rem;letter-spacing:.04em;cursor:pointer;border:2px solid #111}',
    '.sx-bp__btn--buy{background:#111;color:#fff}',
    '.sx-bp__btn--cart{background:#fff;color:#111}',
    '.sx-bp__btn[disabled]{opacity:.6;cursor:wait}',
    '.sx-bp__msg{margin:0;font-size:.85rem;color:#b42318}',
    '.sx-bp-hide{display:none!important}',
    'body.sx-bp-on .sento-promo--qty{display:none!important}',
    '.sx-bp-buy-now{width:100%;margin:0 0 8px}',
    '.sx-bp-float{position:fixed;left:0;right:0;bottom:0;z-index:40;padding:12px 16px calc(12px + env(safe-area-inset-bottom));background:linear-gradient(transparent,#fff 28%);transform:translateY(110%);transition:transform .2s;pointer-events:none}',
    '.sx-bp-float.is-visible{transform:none;pointer-events:auto}',
    '.sx-bp-float .sx-bp__btn{width:100%}'
  ].join('\n');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var money = function (cents) {
    return 'LE ' + (Number(cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  var handleFromPath = function () {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };

  var state = { tier: 1, picks: {} };
  var product = null;
  var tiers = null;
  var busy = false;
  var mounting = false;
  var floating = null;
  var floatingWatch = null;

  var offersFromPage = function () {
    try {
      var offers = JSON.parse(document.getElementById('sento-cod-config').textContent).offers;
      return Array.isArray(offers) ? offers : [];
    } catch (e) {
      return Array.isArray(window._RSI_COD_FORM_QUANTIY_OFFERS) ? window._RSI_COD_FORM_QUANTIY_OFFERS : [];
    }
  };

  var variantById = function (id) {
    return product.variants.find(function (v) { return String(v.id) === String(id); });
  };

  var nativeForm = function () {
    var main = document.querySelector('#MainContent');
    return main && (
      main.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') ||
      main.querySelector('form[action*="/cart/add"]')
    );
  };

  var currentVariantId = function () {
    var fromForm = nativeForm() && nativeForm().querySelector('input[name="id"]');
    if (fromForm && variantById(fromForm.value)) return fromForm.value;
    var param = new URLSearchParams(location.search).get('variant');
    var v = param && variantById(param);
    if (v && v.available) return v.id;
    var first = product.variants.find(function (x) { return x.available; }) || product.variants[0];
    return first.id;
  };

  var currentQuantity = function () {
    var input = nativeForm() && [...nativeForm().querySelectorAll('input[name="quantity"]')].find(function (field) { return field.offsetParent || field.type === 'hidden' || field.type === 'number'; });
    var n = Number(input && input.value);
    return n > 0 ? n : 1;
  };

  var ensurePicks = function () {
    var cur = currentVariantId();
    tiers.forEach(function (t) {
      var q = Number(t.qty);
      var arr = state.picks[q] || [];
      for (var k = 0; k < q; k++) if (!arr[k]) arr[k] = cur;
      state.picks[q] = arr;
    });
    if (state.lastVariant !== cur) {
      tiers.forEach(function (t) { state.picks[Number(t.qty)][0] = cur; });
      state.lastVariant = cur;
    }
  };

  var tierTotals = function (tier) {
    var q = Number(tier.qty);
    var ids = state.picks[q];
    var total = ids.reduce(function (sum, id) {
      var v = variantById(id);
      return sum + (v ? Number(v.price) : 0);
    }, 0);
    var saved = 0;
    if (q > 1) {
      var v = Number(tier.ds && tier.ds.v) || 0;
      var t = (tier.ds && tier.ds.t) || '';
      if (t === 'fixed') saved = Math.min(v, total);
      else if (/percent/i.test(t)) saved = Math.round((total * v) / 100);
    }
    return { was: total, now: total - saved, saved: saved };
  };

  var optionsHtml = function (selectedId) {
    return product.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (String(v.id) === String(selectedId) ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
        esc(v.title === 'Default Title' ? 'One size' : v.title) + (v.available ? '' : ' (sold out)') + '</option>';
    }).join('');
  };

  var render = function (el) {
    var img = product.featured_image ? (product.featured_image.indexOf('//') === 0 ? 'https:' + product.featured_image : product.featured_image) : '';
    var html = '<p class="sx-bp__h">Select a bundle</p>';
    tiers.forEach(function (tier) {
      var q = Number(tier.qty);
      var on = state.tier === q;
      var tot = tierTotals(tier);
      var title = q === 1 ? 'Single' : (tier.title || ('Buy ' + q));
      html += '<label class="sx-bp__card' + (on ? ' is-on' : '') + '">' +
        '<input class="sx-bp__radio" type="radio" name="sx-bp-tier" value="' + q + '"' + (on ? ' checked' : '') + '>' +
        '<span class="sx-bp__row">' +
          (img ? '<img class="sx-bp__thumb" src="' + esc(img) + '&width=160" alt="">' : '') +
          '<span class="sx-bp__txt"><span class="sx-bp__title">' + esc(title) + '</span>' +
            (tot.saved > 0 ? '<span class="sx-bp__save">SAVE ' + money(tot.saved) + '</span>' : '') +
          '</span>' +
          '<span class="sx-bp__prices"><span class="sx-bp__now">' + money(tot.now) + '</span>' +
            (tot.saved > 0 ? '<span class="sx-bp__was">' + money(tot.was) + '</span>' : '') +
          '</span>' +
        '</span>';
      if (on) {
        html += '<span class="sx-bp__picks">';
        for (var k = 0; k < q; k++) {
          html += '<span class="sx-bp__pick">' + (q > 1 ? '<span>Piece ' + (k + 1) + '</span>' : '') +
            '<select data-slot="' + k + '" aria-label="' + esc((product.options && product.options[0] && product.options[0].name) || 'Size') + ' for piece ' + (k + 1) + '">' +
            optionsHtml(state.picks[q][k]) + '</select></span>';
        }
        html += '</span>';
      }
      html += '</label>';
    });
    html += '<div class="sx-bp__btns">' +
      '<button type="button" class="sx-bp__btn sx-bp__btn--buy" data-act="buy">ORDER NOW</button>' +
      '<button type="button" class="sx-bp__btn sx-bp__btn--cart" data-act="cart">ADD TO CART</button>' +
      '</div><p class="sx-bp__msg" role="alert" hidden></p>';
    el.innerHTML = html;
  };

  var addItems = async function (items) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) {
      var err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || 'Could not add to cart.');
    }
    var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'sx-bp', data: { source: 'sx-bp', itemCount: cart.item_count } }
    }));
    if (window.SentoOffers) await window.SentoOffers.apply();
    return cart;
  };

  var goCheckout = function () {
    location.href = '/checkout';
  };

  var addToCart = async function (el, goToCart) {
    if (busy) return;
    busy = true;
    var buttons = el.querySelectorAll('.sx-bp__btn');
    buttons.forEach(function (b) { b.disabled = true; });
    var msg = el.querySelector('.sx-bp__msg');
    msg.hidden = true;
    try {
      var counts = {};
      state.picks[state.tier].slice(0, state.tier).forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
      await addItems(items);
      if (goToCart) {
        goCheckout();
        return;
      }
    } catch (e) {
      msg.textContent = e.message || 'Something went wrong, please try again.';
      msg.hidden = false;
    }
    buttons.forEach(function (b) { b.disabled = false; });
    busy = false;
  };

  var orderNative = async function (button) {
    if (busy) return;
    busy = true;
    button.disabled = true;
    try {
      await addItems([{ id: Number(currentVariantId()), quantity: currentQuantity() }]);
      goCheckout();
      return;
    } catch (e) {
      button.disabled = false;
      busy = false;
    }
  };

  var watchFloat = function (anchor) {
    if (!floating) {
      floating = document.createElement('div');
      floating.className = 'sx-bp-float';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sx-bp__btn sx-bp__btn--buy';
      btn.textContent = 'ORDER NOW';
      btn.addEventListener('click', function () {
        var onPage = document.querySelector('.sx-bp__btn--buy[data-act="buy"], .sx-bp-buy-now');
        if (onPage) onPage.click();
      });
      floating.appendChild(btn);
      document.body.appendChild(floating);
    }
    if (floatingWatch) floatingWatch.disconnect();
    floatingWatch = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      floating.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    floatingWatch.observe(anchor);
  };

  var hideNative = function (area) {
    var form = area.querySelector('form[action*="/cart/add"]');
    if (form) {
      var wrap = form.closest('product-form-component') || form;
      wrap.classList.add('sx-bp-hide');
    }
  };

  var getArea = function () {
    var main = document.querySelector('#MainContent');
    return main && (main.querySelector('.product-details') || main.querySelector('product-info') || main);
  };

  var tiersForProduct = function () {
    var offers = offersFromPage();
    var rel = offers.filter(function (o) {
      return o.isActive && o.type === 'quantity-offer' && (o.pIds || []).map(String).indexOf(String(product.id)) !== -1;
    });
    if (!rel.length) return [];
    var seen = {};
    return [{ qty: 1, title: 'Single' }].concat(
      rel.reduce(function (a, o) { return a.concat(o.offers || []); }, [])
        .filter(function (t) { return Number(t.qty) > 1 && Number(t.ds && t.ds.v) > 0; })
    ).filter(function (t) {
      var q = Number(t.qty);
      if (seen[q]) return false;
      seen[q] = true;
      return true;
    }).sort(function (a, b) { return Number(a.qty) - Number(b.qty); });
  };

  var mountPicker = function (area) {
    ensurePicks();
    if (!tiers.some(function (t) { return Number(t.qty) === state.tier; })) state.tier = 1;

    var el = document.createElement('div');
    el.className = 'sx-bp';
    render(el);

    var form = area.querySelector('form[action*="/cart/add"]');
    var host = form && (form.closest('product-form-component') || form);
    if (host && host.parentElement) host.insertAdjacentElement('beforebegin', el);
    else area.appendChild(el);

    el.addEventListener('change', function (e) {
      if (e.target.matches('.sx-bp__radio')) {
        state.tier = Number(e.target.value);
        render(el);
      } else if (e.target.matches('select[data-slot]')) {
        state.picks[state.tier][Number(e.target.dataset.slot)] = e.target.value;
        var slot = e.target.dataset.slot;
        render(el);
        var again = el.querySelector('select[data-slot="' + slot + '"]');
        if (again) again.focus();
      }
    });
    el.addEventListener('click', function (e) {
      var b = e.target.closest('.sx-bp__btn');
      if (b) addToCart(el, b.dataset.act === 'buy');
    });

    document.body.classList.add('sx-bp-on');
    hideNative(area);
    watchFloat(el.querySelector('.sx-bp__btn--buy'));
  };

  var mountSimpleBuy = function (area) {
    var form = nativeForm();
    if (!form || form.querySelector('.sx-bp-buy-now')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'sx-bp__btn sx-bp__btn--buy sx-bp-buy-now';
    button.textContent = 'ORDER NOW';
    button.addEventListener('click', function () { orderNative(button); });
    var buttonsWrap = form.querySelector('.product-form-buttons');
    if (buttonsWrap && buttonsWrap.parentElement) buttonsWrap.insertAdjacentElement('beforebegin', button);
    else {
      var host = form.querySelector('.product-form-buttons') || form;
      var add = host.querySelector('.add-to-cart-button, [name="add"], button[type="submit"]');
      if (add) add.insertAdjacentElement('beforebegin', button);
      else host.appendChild(button);
    }
    watchFloat(button);
  };

  var mount = async function () {
    if (mounting || !handleFromPath()) return;
    var area = getArea();
    if (!area) return;
    if (area.querySelector('.sx-bp')) { hideNative(area); return; }
    if (area.querySelector('.sx-bp-buy-now')) return;
    mounting = true;
    try {
      if (!product) {
        var r = await fetch('/products/' + encodeURIComponent(handleFromPath()) + '.js', { headers: { Accept: 'application/json' } });
        if (!r.ok) return;
        product = await r.json();
      }
      if (!product.variants.some(function (v) { return v.available; })) return;
      if (!tiers) tiers = tiersForProduct();
      area = getArea();
      if (!area || area.querySelector('.sx-bp') || area.querySelector('.sx-bp-buy-now')) return;
      if (tiers.length >= 2) mountPicker(area);
      else mountSimpleBuy(area);
    } finally {
      mounting = false;
    }
  };

  var start = function () {
    if (!/\/products\//.test(location.pathname)) return;
    mount();
    var main = document.querySelector('#MainContent');
    if (!main) return;
    var frame = 0;
    new MutationObserver(function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(mount);
    }).observe(main, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
